import elderlyCareImage from "@/assets/blog-elderly-care-crisis-hero.jpg";
import diagnosticDelayImage from "@/assets/blog-diagnostic-delay-hero.jpg";
import privatePracticeGrowthImage from "@/assets/blog-private-practice-growth-hero.jpg";
import noShowsImage from "@/assets/blog-no-shows-system-hero.jpg";
import insuranceImage from "@/assets/blog-insurance-ai-hero.jpg";
import heroImage from "@/assets/blog-simple-vs-agentic-ai.jpg";
import constructionImage from "@/assets/blog-construction-ai-hero.jpg";
import healthcareImage from "@/assets/blog-healthcare-ai-hero.jpg";
import lawFirmsImage from "@/assets/blog-law-firms-ai-hero.jpg";
import realEstateImage from "@/assets/blog-real-estate-ai-hero.jpg";
import retailImage from "@/assets/blog-retail-ai-hero.jpg";
import educationImage from "@/assets/blog-education-ai-hero.jpg";
import hospitalityImage from "@/assets/blog-hospitality-ai-hero.jpg";
import workflowHealthcareImage from "@/assets/blog-workflow-healthcare-hero.jpg";
import ecommerceDiscoveryImage from "@/assets/blog-ecommerce-discovery-hero.jpg";
import personalisedCareImage from "@/assets/blog-personalised-care-hero.jpg";
import manufacturingImage from "@/assets/blog-manufacturing-ai-hero.jpg";
import cliniciansAdminImage from "@/assets/blog-clinicians-admin-hero.jpg";
import travelPersonalisationImage from "@/assets/blog-travel-personalisation-hero.jpg";
import bestLawyersImage from "@/assets/blog-best-lawyers-hero.jpg";
import aiReceptionistImage from "@/assets/blog-ai-receptionist-hero.jpg";
import quantitySurveyingImage from "@/assets/blog-quantity-surveying-hero.jpg";
import newPatientJourneyImage from "@/assets/blog-new-patient-journey-hero.jpg";
import teacherRetentionImage from "@/assets/blog-teacher-retention-hero.jpg";
import clinicalDocumentationImage from "@/assets/blog-clinical-documentation-hero.jpg";
import clinicianBurnoutImage from "@/assets/blog-clinician-burnout-hero.jpg";
import dataFragmentationImage from "@/assets/blog-data-fragmentation-hero.jpg";
import chronicDiseaseImage from "@/assets/blog-chronic-disease-hero.jpg";
import medicationAdherenceImage from "@/assets/blog-medication-adherence-hero.jpg";
import healthInequalityImage from "@/assets/blog-health-inequality-hero.jpg";
import preventionImage from "@/assets/blog-prevention-population-health-hero.jpg";
import mentalHealthImage from "@/assets/blog-mental-health-crisis-hero.jpg";
import nhsWaitingListImage from "@/assets/blog-nhs-waiting-list-hero.jpg";
import wearableMonitoringImage from "@/assets/blog-wearable-monitoring-hero.jpg";
import generativeAiClinicImage from "@/assets/blog-generative-ai-clinic-hero.jpg";
import practiceCapacityImage from "@/assets/blog-clinic-capacity-hero.jpg";
import dataEntryErrorsImage from "@/assets/blog-data-entry-errors-hero.jpg";
import referralManagementImage from "@/assets/blog-referral-management-hero.jpg";
import unansweredMessagesImage from "@/assets/blog-unanswered-messages-hero.jpg";
import projectsFailImage from "@/assets/blog-projects-fail-hero.jpg";
import insuranceAdminImage from "@/assets/blog-insurance-admin-hero.jpg";
import automationCapabilityImage from "@/assets/blog-automation-capability-hero.jpg";
import firstNinetyDaysImage from "@/assets/blog-first-90-days-hero.jpg";
import cqcComplianceImage from "@/assets/blog-cqc-compliance-hero.jpg";
import smallBusinessAdvantageImage from "@/assets/blog-small-business-advantage-hero.jpg";
import practiceInboxTriageImage from "@/assets/blog-practice-inbox-triage-hero.jpg";
import founderBlockerImage from "@/assets/blog-founder-blocker-hero.jpg";
import honestyDealImage from "@/assets/blog-honesty-deal-boardroom.jpg";
import youngerBrotherImage from "@/assets/blog-younger-brother-hero.jpg";
import fifteenPersonBusinessImage from "@/assets/blog-15-person-business-hero.jpg";
import trustUnderstandingImage from "@/assets/blog-trust-understanding-hero.jpg";
import slackPilotImage from "@/assets/blog-slack-pilot-hero.jpg";
import receptionistTrainedImage from "@/assets/blog-receptionist-trained-hero.jpg";
import receptionDesksImage from "@/assets/blog-reception-desks-hero.jpg";
import afterHoursCallImage from "@/assets/blog-740pm-call-hero.jpg";
import dataReadinessImage from "@/assets/blog-data-readiness-hero.jpg";
import discoveryNinetySecondsImage from "@/assets/blog-discovery-ninety-seconds-hero.jpg";














export interface BlogPost {
  slug: string;
  image: string;
  category: string;
  date: string;
  title: string;
  listingTitle?: string;
  excerpt: string;
  author: string;
  readTime: string;
}

export const posts: BlogPost[] = [
  {
    slug: "/blog/first-ninety-seconds-discovery-call",
    image: discoveryNinetySecondsImage,
    category: "Strategy",
    date: "2 November 2026",
    title: "The first ninety seconds of a discovery call decide our next steps",
    listingTitle: "Your discovery call is decided in the first ninety seconds.",
    excerpt: "Most discovery calls turn into a presentation within two minutes and the buyer disengages. Here is how one opening question changes everything that follows.",
    author: "Ayomide Oke",
    readTime: "5 min read",
  },
  {
    slug: "/blog/data-not-as-bad-as-you-think",
    image: dataReadinessImage,
    category: "Strategy",
    date: "October 2026",
    title: "Your Data Is Not as Bad as You Think",
    listingTitle: "Your data is not too messy.",
    excerpt:
      "Most practices think their data is too messy for automation. It rarely is. Here is how a narrower first question makes untidy data usable, and where it is not.",
    author: "Ayomide Oke",
    readTime: "5 min read",
  },
  {
    slug: "/blog/call-at-740pm-after-hours",

    image: afterHoursCallImage,
    category: "Healthcare",
    date: "October 2026",
    title: "What Happens to a Call at 7.40pm When Nobody Is There to Answer It",
    listingTitle: "Somebody rang your practice at 7.40pm and hung up.",
    excerpt:
      "Callers who reach voicemail after hours rarely leave a message and ring the next practice instead. Here is what happens to that call and how to catch it.",
    author: "Ayomide Oke",
    readTime: "4 min read",
  },
  {
    slug: "/blog/what-reception-desks-taught-us",
    image: receptionDesksImage,
    category: "Strategy",
    date: "October 2026",
    title: "What Reception Desks Taught Us on the Streets of Bedford",
    listingTitle: "The front desk is the most informed place in your practice.",
    excerpt:
      "We walked into private practices in Bedford without an appointment and learned who really knows how a practice runs. Here is what the front desk taught us.",
    author: "Ayomide Oke",
    readTime: "4 min read",
  },
  {
    slug: "/blog/receptionist-trained-our-system",
    image: receptionistTrainedImage,
    category: "Healthcare",
    date: "October 2026",
    title: "The receptionist who ended up training our system better than we did",
    listingTitle: "The receptionist knew which patients needed more care.",
    excerpt:
      "A receptionist's two extra questions on rebooking calls caught patients needing a treatment plan change early. Here is how we built that into every booking.",
    author: "Ayomide Oke",
    readTime: "5 min read",
  },
  {
    slug: "/blog/slack-message-enterprise-pilot",
    image: slackPilotImage,
    category: "Strategy",
    date: "October 2026",
    title: "The Slack message that almost ended an enterprise pilot before it had really begun",
    listingTitle: "One slow reply nearly ended a promising enterprise pilot.",
    excerpt:
      "A single unanswered question in an internal meeting nearly paused a promising enterprise pilot. Here is what happened and what we now do differently.",
    author: "Ayomide Oke",
    readTime: "4 min read",
  },
  {
    slug: "/blog/trust-not-understanding",
    image: trustUnderstandingImage,
    category: "Strategy",
    date: "October 2026",
    title: "The Small Clinic That Taught Us Trust Is Not the Same as Understanding",
    listingTitle: "She trusted us completely. She understood almost nothing.",
    excerpt:
      "A client signed off on a technical build without really understanding what she was approving, because she had decided she did not need to if she trusted the people building it. Here is why that made us uncomfortable and what we changed.",
    author: "Ayomide Oke",
    readTime: "5 min read",
  },
  {
    slug: "/blog/15-person-business-enterprise-lesson",
    image: fifteenPersonBusinessImage,
    category: "Strategy",
    date: "October 2026",
    title: "What a 15-person business taught us that we later used to win an enterprise client",
    listingTitle: "A 15-person client taught us how we won a much larger one",
    excerpt:
      "We spent six weeks with a fifteen-person logistics business building one automation. What its owner told us ended up being the exact insight that won us a much larger enterprise client three months later.",
    author: "Ayomide Oke",
    readTime: "6 min read",
  },
  {
    slug: "/blog/younger-brother-family-practice",
    image: youngerBrotherImage,
    category: "Healthcare",
    date: "September 2026",
    title: "The family business that almost said no and what the younger brother taught us about small healthcare practices",
    listingTitle: "The younger brother said no. He was right to protect it.",
    excerpt:
      "Two brothers ran a physiotherapy clinic they had built together over fifteen years. The younger one arrived at our first meeting with his arms folded. Here is what he taught us about how family healthcare businesses actually make decisions.",
    author: "Ayomide Oke",
    readTime: "6 min read",
  },
  {
    slug: "/blog/honesty-almost-cost-us-the-deal",
    image: honestyDealImage,
    category: "Strategy",
    date: "September 2026",
    title: "The first time we told an enterprise client their own project was a bad idea",
    listingTitle: "The honesty that almost cost us the deal.",
    excerpt:
      "We were in a room with senior stakeholders, well into a proposal process, watching a plan take shape that we believed would fail. Here is what we said, what happened after the silence, and what it changed about how we work.",
    author: "Ayomide Oke",
    readTime: "7 min read",
  },
  {
    slug: "/blog/founder-biggest-blocker-automation",
    image: founderBlockerImage,
    category: "Strategy",
    date: "September 2026",
    title:
      "Why the people who would benefit most from automation are usually the last to allow it",
    listingTitle: "The founder is usually the biggest blocker in the business.",
    excerpt:
      "The businesses where automation would free up the most time are frequently the ones where it is hardest to implement. Not because of the technology or the budget. Because of the founder. Here is why and what we do about it.",
    author: "Ayomide Oke",
    readTime: "8 min read",
  },
  {
    slug: "/blog/practice-inbox-triage-system",
    image: practiceInboxTriageImage,
    category: "Healthcare",
    date: "September 2026",
    title:
      "The practice inbox has no triage system and that is costing you patients, revenue, and clinical safety",
    listingTitle: "Your practice inbox has no triage and your patients know it.",
    excerpt:
      "Practice administrators spend 28% of their working week managing an inbox with no systematic triage behind it. A new patient enquiry is 21 times less likely to convert if the response takes more than five minutes. Here is what changes when that system finally exists.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/small-business-advantage-automation-wave",
    image: smallBusinessAdvantageImage,
    category: "Strategy",
    date: "August 2026",
    title:
      "Being a small business now has an advantage and most owners have not realised it yet",
    listingTitle: "The first technology wave that does not favour scale.",
    excerpt:
      "Every previous enterprise technology wave required capital and specialist staff that only large organisations could afford. This one does not. Here is why small businesses have a structural advantage in this shift and what that means in practice.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/cqc-compliance-continuous-private-practice",
    image: cqcComplianceImage,
    category: "Healthcare",
    date: "August 2026",
    title:
      "Compliance is eating your team alive and most of it does not need to be",
    listingTitle: "The CQC has changed its model. Compliance is now continuous.",
    excerpt:
      "The CQC's Single Assessment Framework requires continuous evidence of compliance rather than inspection readiness. 9,000 assessments are planned by September 2026. Here is what that means for private practices and where the administrative burden is actually coming from.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/first-90-days-automation-sequence",
    image: firstNinetyDaysImage,
    category: "Strategy",
    date: "August 2026",
    title:
      "The first ninety days: the exact sequence we would follow to get automation working in your business",
    listingTitle: "The first 90 days of automation done right.",
    excerpt:
      "Most people know they should be doing something with automation and have no idea what the first move is. Here is the exact sequence, in order, that gets a first implementation working and sets up everything that follows.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/insurance-claims-administration-private-practice",
    image: insuranceAdminImage,
    category: "Healthcare",
    date: "August 2026",
    title:
      "Insurance administration is draining your practice and here is where the revenue is going",
    listingTitle: "73% of providers report more denials. Only 14% are automating.",
    excerpt:
      "73% of healthcare providers report rising claim denial rates. 82% say denial reduction is their top priority. Only 14% have automated their claims process. Here is where the revenue is leaking and what fixing it actually looks like.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/business-automation-capability-line",
    image: automationCapabilityImage,
    category: "Strategy",
    date: "August 2026",
    title:
      "What business automation is actually good at, where it fails confidently, and why the gap is not where most people think",
    listingTitle: "The automation capability line is not where you think it is.",
    excerpt:
      "Most businesses either overestimate or underestimate what automation can do. Here is a plain map of where the capability line currently sits, what delivers real returns, and why the boring applications almost always win.",
    author: "Ayomide Oke",
    readTime: "8 min read",
  },
  {
    slug: "/blog/why-projects-fail-four-questions",
    image: projectsFailImage,
    category: "Strategy",
    date: "August 2026",
    title: "Why 80% of AI projects die quietly and the four questions that would have saved most of them",
    listingTitle: "80% of AI projects fail and these four questions show why.",
    excerpt:
      "RAND Corporation analysed 2,400 enterprise AI initiatives and found 80.3% failed to deliver business value. The reasons are almost never technical. Here are the four questions that predict whether a project will survive.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/unanswered-patient-messages",
    image: unansweredMessagesImage,
    category: "Healthcare",
    date: "August 2026",
    title: "Every unanswered patient message costs you more than you realise",
    listingTitle: "Patients switch providers over communication and 69% of them say so.",
    excerpt:
      "69% of patients will switch providers over poor communication, up from 51% in 2023. Practices miss between 23% and 42% of incoming calls and 85% of those callers never try again. Here is where the communication gap is actually costing practices.",
    author: "Ayomide Oke",
    readTime: "8 min read",
  },
  {
    slug: "/blog/referral-management-patient-pathway",
    image: referralManagementImage,
    category: "Healthcare",
    date: "August 2026",
    title: "Referral management is where patients and revenue both get lost",
    listingTitle: "One in seven NHS referrals is lost, delayed, or rejected.",
    excerpt:
      "One in seven patients referred by their GP ends up stuck waiting for care that never arrived. 71% only find out after chasing it themselves. Here is what is actually happening in referral management and where the gaps are costing patients and practices.",
    author: "Ayomide Oke",
    readTime: "8 min read",
  },
  {
    slug: "/blog/clinical-data-entry-errors-document-automation",
    image: dataEntryErrorsImage,
    category: "Healthcare",
    date: "August 2026",
    title: "Your team is still typing patient data by hand and the error rate is higher than anyone is tracking",
    listingTitle: "21% of patients who check their records find an error in them.",
    excerpt:
      "Manual clinical data entry has a 3 to 5% error rate under typical working conditions. 21% of patients who review their records find mistakes and 42% of those errors are described as serious. Here is what document automation actually changes.",
    author: "Ayomide Oke",
    readTime: "8 min read",
  },
  {
    slug: "/blog/private-practice-capacity-utilisation-uk",
    image: practiceCapacityImage,
    category: "Healthcare",
    date: "August 2026",
    title: "The revenue your practice is missing is not from new patients.",
    listingTitle: "The average UK clinic runs at 72% capacity and here is the gap.",
    excerpt:
      "The average UK private practice diary utilisation rate is 72.3% according to a 2026 survey of 700 clinic owners. Here is what that gap actually costs, where it comes from, and what closing it looks like without adding staff or clinical sessions.",
    author: "Ayomide Oke",
    readTime: "8 min read",
  },
  {
    slug: "/blog/ambient-scribing-clinical-documentation-nhs",
    image: generativeAiClinicImage,
    category: "Healthcare",
    date: "August 2026",
    title: "Generative AI has arrived in the clinic and here is what it actually looks like",
    listingTitle: "Generative AI in the clinic is no longer an experiment.",
    excerpt:
      "The NHS has published its ambient scribing results. 23.5% more time with patients. 47 minutes saved per A&E clinician per shift. Here is what generative AI in clinical settings actually looks like now and which applications are ready.",
    author: "Ayomide Oke",
    readTime: "8 min read",
  },
  {
    slug: "/blog/wearable-health-data-remote-monitoring",
    image: wearableMonitoringImage,
    category: "Healthcare",
    date: "August 2026",
    title: "Your patients are already wearing continuous health monitors and the clinical system has no way to receive the data",
    listingTitle: "Your patients are generating clinical data nobody is reading.",
    excerpt:
      "Millions of people in the UK now wear continuous health monitors. The clinical data they generate is largely disconnected from the healthcare system. Here is what connecting it changes for patients, practices, and outcomes.",
    author: "Ayomide Oke",
    readTime: "8 min read",
  },
  {
    slug: "/blog/nhs-waiting-list-patient-pathway-management",
    image: nhsWaitingListImage,
    category: "Healthcare",
    date: "July 2026",
    title: "When 7.3 million people are waiting for NHS treatment the numbers tell only part of the story",
    listingTitle: "The waiting list has 7.3 million names behind the numbers.",
    excerpt:
      "There are 7.3 million people on NHS waiting lists in England and 548,000 were removed in the past year without receiving treatment. Here is what is actually happening inside the waiting list and where the real inefficiencies are costing patients time they cannot afford.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/mental-health-waiting-times-digital-support",
    image: mentalHealthImage,
    category: "Healthcare",
    date: "July 2026",
    title: "The mental health crisis has been building for a decade and the workforce cannot grow fast enough to meet it",
    listingTitle: "One in four will need help. One in eight will get it.",
    excerpt:
      "There are 1.7 million people on mental health waiting lists in England. Mental health services received 5.2 million referrals in 2024. Here is where digital support is already scaling access in a system that cannot grow fast enough.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {

    slug: "/blog/prevention-population-health-nhs",
    image: preventionImage,
    category: "Healthcare",
    date: "July 2026",
    title: "We keep treating the problem instead of preventing it.",
    listingTitle: "The NHS treats first and here is the cost of that choice",
    excerpt:
      "Prevention returns a median of £14 for every £1 invested yet only 5% of NHS funding goes to preventive care. Here is what population health management and proactive outreach are already delivering.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/health-inequality-access-gap",
    image: healthInequalityImage,
    category: "Healthcare",
    date: "July 2026",
    title: "Health inequalities are not inevitable and technology is proving it.",
    listingTitle: "Your postcode still determines your health and it's time that changes",
    excerpt:
      "There is a 19-year gap in healthy life expectancy between the most and least deprived areas in England. Here is where technology is already closing the access gap and what that changes for the patients who have historically had the least.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/medication-adherence-non-adherence-nhs",
    image: medicationAdherenceImage,
    category: "Healthcare",
    date: "July 2026",
    title: "The prescription was written but that does not mean the medication was taken",
    listingTitle: "The medication isn't working if nobody is taking it.",
    excerpt:
      "Medication non-adherence costs the NHS over £930 million a year and half of all chronic disease patients are not taking their prescriptions as directed. Here's what the evidence shows about why, and what actually changes behaviour.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/chronic-disease-continuous-monitoring",
    image: chronicDiseaseImage,
    category: "Healthcare",
    date: "July 2026",
    title: "Chronic disease is managing us and it is time we managed it back",
    listingTitle: "The quarterly check-up cannot manage a condition that changes daily.",
    excerpt:
      "70% of NHS spending goes on chronic disease. The care model is built on appointments every three to six months. Here's why that mismatch has consequences and what continuous monitoring changes.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/elderly-care-crisis-intervention",
    image: elderlyCareImage,
    category: "Healthcare",
    date: "July 2026",
    title: "The elderly care crisis nobody saw coming until everyone could see it",
    listingTitle: "The elderly care gap is here. The system isn't ready.",
    excerpt:
      "Falls cost the NHS £2.3 billion a year. Dementia takes 3.5 years to diagnose. The UK's elderly care system is under structural pressure. Here's where earlier intervention changes outcomes.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/patient-data-fragmentation",
    image: dataFragmentationImage,
    category: "Healthcare",
    date: "July 2026",
    title: "Your patient's data is everywhere and nowhere at the same time",
    listingTitle: "Every clinician sees a fragment. Here's what that costs.",
    excerpt:
      "237 million medication errors occur in England every year. Incomplete patient information at the point of care is a documented pattern of harm. Here's what connecting that data actually changes.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/diagnostic-delay-pattern-recognition",
    image: diagnosticDelayImage,
    category: "Healthcare",
    date: "July 2026",
    title: "The pattern was always there. The system just could not see it.",
    listingTitle: "Nine Years for a Diagnosis That Should Take Months.",
    excerpt:
      "The average UK endometriosis diagnosis now takes over nine years. Diagnostic delay across multiple conditions is getting worse, not better. Here's what the data shows - and where better pattern recognition changes outcomes.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/clinician-burnout-system-problem",
    image: clinicianBurnoutImage,
    category: "Healthcare",
    date: "July 2026",
    title: "Clinician burnout is a system problem and operational tools are part of the system fix",
    listingTitle: "Burnout is not a clinician problem. It is a system one.",
    excerpt:
      "One in three NHS doctors cannot cope with their workload at least once a week. Here's what is actually driving clinical burnout and what reducing the system load looks like in practice.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/private-practice-growth-without-headcount",
    image: privatePracticeGrowthImage,
    category: "Healthcare",
    date: "July 2026",
    title: "How private practices are growing without adding headcount",
    listingTitle: "Growing Revenue But Not Margin? More Headcount Isn't the Answer.",
    excerpt:
      "Most private practices respond to growth by adding staff. Here's why that keeps margins flat and what separates the practices growing profitably from the ones just getting bigger.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/no-shows-fixable-system-problem",
    image: noShowsImage,
    category: "Healthcare",
    date: "July 2026",
    title: "No-shows are not bad luck - they are a fixable system problem",
    listingTitle: "Your no-show rate isn't bad luck. It's a fixable system problem.",
    excerpt:
      "No-shows in UK private clinics run at 10 to 18% depending on specialty. Here's why they happen, what the patterns actually tell you, and how the best-run practices bring them under control.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/clinical-documentation-burden",
    image: clinicalDocumentationImage,
    category: "Healthcare",
    date: "July 2026",
    title: "Clinical documentation is consuming the time that should go to patients",
    listingTitle: "Two hours of paperwork for every hour with a patient. That has to change.",
    excerpt:
      "Clinical documentation consumes more of a clinician's day than most practices track. Here's what the burden actually looks like and what happens when practices start to reduce it.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },

  {
    slug: "/blog/teacher-retention-admin-burden",
    image: teacherRetentionImage,
    category: "Education",
    date: "July 2026",
    title: "Teachers are not leaving because of the children - they are leaving because of the admin",
    listingTitle: "One in three teachers walks away. Workload is the reason.",
    excerpt:
      "Teacher retention isn't primarily a pay problem. Here's what the data actually shows about why teachers leave - and what reducing the administrative weight really looks like in practice.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/new-patient-journey-first-impressions",
    image: newPatientJourneyImage,
    category: "Healthcare",
    date: "July 2026",
    title: "Most private practices are losing new patients before they even arrive.",
    listingTitle: "Most private practices are losing new patients before they even arrive.",
    excerpt:
      "The new patient journey is won or lost before the first appointment. Here's where most practices are losing patients they paid to attract, and what the difference looks like.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/quantity-surveying-data",
    image: quantitySurveyingImage,
    category: "Construction",
    date: "June 2026",
    title: "Your QS firm has the data. Are you actually using all of it?",
    listingTitle: "Your QS firm has the data. Are you actually using all of it?",
    excerpt:
      "Quantity surveying has always been a data profession. Here's why the firms using that data better than their competitors are pulling ahead and what that actually looks like in practice.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/reception-management-missed-calls-healthcare",
    image: aiReceptionistImage,
    category: "Healthcare",
    date: "June 2026",
    title: "Every missed call is a patient walking to your competitor.",
    listingTitle: "Every missed call is a patient walking to your competitor.",
    excerpt:
      "A missed call is rarely just a missed call. It is a patient who needed something and found it somewhere else. Here's what that is actually costing your practice.",
    author: "Ayomide Oke",
    readTime: "8 min read",
  },
  {
    slug: "/blog/best-lawyers-least-time-practising-law",
    image: bestLawyersImage,
    category: "Legal",
    date: "June 2026",
    title: "Why the best lawyers spend the least time practising law",
    listingTitle: "Your lawyers trained for the work that matters. Why is admin getting in the way?",
    excerpt:
      "Lawyers lose hundreds of hours a year to admin that has nothing to do with legal work. Here's what changes when firms stop accepting that as normal.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/insurance-claims-smarter-risk",
    image: insuranceImage,
    category: "Finance",
    date: "June 2026",
    title: "Faster claims, smarter risk: how AI is fixing the industry nobody trusts.",
    listingTitle: "The claims process is where customer trust is won or lost and where most insurers are losing.",
    excerpt:
      "Insurance customers form their opinion of you at the moment they make a claim. Here's what the fastest, most trusted insurers are doing differently.",
    author: "Ayomide Oke",
    readTime: "10 min read",
  },
  {
    slug: "/blog/personalised-travel-experiences",
    image: travelPersonalisationImage,
    category: "Travel",
    date: "June 2026",
    title: "Unforgettable journeys, intelligently delivered: how AI is making travel personal again.",
    listingTitle: "Generic travel experiences are losing you repeat bookings.",
    excerpt:
      "In tourism, customers remember the feeling, not the technology. Here's why personalisation at scale has become the defining gap between the brands winning repeat bookings and those losing them.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/great-clinicians-drowning-in-admin",
    image: cliniciansAdminImage,
    category: "Healthcare",
    date: "June 2026",
    title: "Great clinicians are drowning in admin and your patients are paying for it.",
    listingTitle: "Your clinicians got into medicine to help people. So why is admin stopping them?",
    excerpt:
      "Most clinical time disappears into admin that has nothing to do with medicine. Here's what practices look like when that changes, and what better patient care actually delivers.",
    author: "Ayomide Oke",
    readTime: "8 min read",
  },
  {
    slug: "/blog/factory-of-the-future-intelligent-manufacturing",
    image: manufacturingImage,
    category: "Manufacturing",
    date: "June 2026",
    title: "The factory of the future is already running",
    listingTitle: "The factory of the future is already running, are you?",
    excerpt:
      "The manufacturers running leaner, breaking down less, and shipping more reliably are not planning to adopt AI. They already have. Here's what intelligent operations actually looks like.",
    author: "Ayomide Oke",
    readTime: "10 min read",
  },
  {
    slug: "/blog/personalised-care-precision-medicine",
    image: personalisedCareImage,
    category: "Healthcare",
    date: "June 2026",
    title: "Personalised care, precision medicine, and AI driven patient engagement: healthcare is getting personal",
    listingTitle: "Why personalised care is changing and what that means for healthcare",
    excerpt:
      "Every patient is different, yet most healthcare still treats them the same. Learn how precision medicine and AI driven patient engagement are changing that, and what it means for providers.",
    author: "Ayomide Oke",
    readTime: "10 min read",
  },
  {
    slug: "/blog/ecommerce-product-discovery",
    image: ecommerceDiscoveryImage,
    category: "Ecommerce",
    date: "June 2026",
    title: "Why online shoppers leave without buying",
    listingTitle: "Why online shoppers leave without buying",
    excerpt:
      "The average ecommerce site loses 97 out of 100 visitors. Learn why product discovery is the problem most retailers ignore, and what fixing it actually looks like.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/workflow-automation-healthcare-operations",
    image: workflowHealthcareImage,
    category: "Healthcare",
    date: "June 2026",
    title: "Why clinicians spend 28 hours per week on admin and how to stop it",
    listingTitle: "Workflow automation and efficiency in healthcare operations: the change that cannot wait",
    excerpt:
      "Healthcare staff are drowning in manual processes. Learn why workflow automation is the missing piece that frees clinicians to focus on patient care.",
    author: "Ayomide Oke",
    readTime: "7 min read",
  },
  {
    slug: "/blog/predictive-construction-delays",
    image: constructionImage,
    category: "Construction",
    date: "June 2026",
    title: "Why construction projects overrun and how to stop it before it starts",
    excerpt:
      "Construction delays are costing the industry billions. Learn why projects overrun, what patterns AI can spot early, and how to prevent expensive cascades.",
    author: "Ayomide Oke",
    readTime: "7 min read",
  },
  {
    slug: "/blog/personalised-guest-experience-hospitality",
    image: hospitalityImage,
    category: "Hospitality",
    date: "June 2026",
    title: "AI personalised guest experiences: transforming hospitality in 2026",
    excerpt:
      "Most hotels still deliver generic experiences. Here's how AI personalisation transforms guest journeys, increases revenue, and sets your property apart from competitors.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/personalised-learning-education",
    image: educationImage,
    category: "Education",
    date: "June 2026",
    title: "AI personalised learning: transforming education through adaptive systems",
    excerpt:
      "The traditional classroom teaches to the middle. Here's how AI personalised learning is changing that, and what it means for students, teachers, and institutions.",
    author: "Ayomide Oke",
    readTime: "10 min read",
  },
  {
    slug: "/blog/retail-personalisation",
    image: retailImage,
    category: "Retail",
    date: "June 2026",
    title: "AI personalisation for retail: the impact on sales and customer experience",
    excerpt:
      "Retail has a relevance problem. Here's how AI personalisation at scale solves it and drives measurable revenue growth for modern retailers.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/estate-agent-productivity",
    image: realEstateImage,
    category: "Real estate",
    date: "June 2026",
    title: "Will AI replace real estate agents? The honest answer in 2026",
    excerpt:
      "AI won't replace great agents. It will replace the agents who refuse to use it. Here's what's actually happening in property right now.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/small-law-firm-efficiency",
    image: lawFirmsImage,
    category: "Legal",
    date: "June 2026",
    title: "Why small law firms should embrace AI before it is too late",
    excerpt:
      "Small law firms are falling behind. Here's what AI actually does well in legal practice, why waiting costs you money, and how to start without overhauling everything.",
    author: "Ayomide Oke",
    readTime: "9 min read",
  },
  {
    slug: "/blog/private-practice-management",
    image: healthcareImage,
    category: "Healthcare",
    date: "May 2026",
    title: "Healthcare and AI: the opportunity private practices are sleeping on",
    excerpt:
      "97% of new NHS dental patients can't get an appointment. Private practices have never had more opportunity, or more competition. Here's how AI changes the game.",
    author: "Ayomide Oke",
    readTime: "8 min read",
  },
  {
    slug: "/blog/simple-vs-agentic-automation",
    image: heroImage,
    category: "Strategy",
    date: "May 2026",
    title: "Simple AI vs agentic AI: what every business needs to understand right now",
    excerpt:
      "The terms get thrown around constantly. Here is what they actually mean, and why the gap between them is now the defining operational advantage for UK businesses.",
    author: "Ayomide Oke",
    readTime: "7 min read",
  },
];
